import { FC } from 'react';
import { BLOCKS, MARKS } from '@contentful/rich-text-types';
import cn from 'classnames';

import classes from 'src/styles/_commonClasses.module.scss';
import { Content, Title } from 'components/Shared/SharedComponents';
import type { RichTextParsersConfig } from 'types/objectTypes';
import type { ImageWrapper } from 'src/__generated__/graphqlTypes';

import styles from './PlainItemsWithDescription.module.scss';
import { Icon } from './Icon';

import type { PlainItemInterface } from '../config/declarations';

const getHClasses = (heading: 'H2' | 'H3' | 'H4') => cn(
  styles.liTitle,
  styles[`liTitle${heading}`],
);

const parsersConfig: RichTextParsersConfig = {
  [BLOCKS.HEADING_2]: {
    classNames: getHClasses('H2'),
  },
  [BLOCKS.HEADING_3]: {
    classNames: getHClasses('H3'),
  },
  [BLOCKS.HEADING_4]: {
    classNames: getHClasses('H4'),
  },
  [BLOCKS.PARAGRAPH]: {
    classNames: styles.liParagraph,
  },
  [MARKS.BOLD]: {
    classNames: classes.textBold,
  },
};

const PlainItem: FC<PlainItemInterface> = ({
  block,
  siblingsAmount,
}) => {
  if (!block) {
    return null;
  }

  const { image, entryName, richTitle, content, imagesCollection } = block;
  const images = (imagesCollection?.items || []) as Array<ImageWrapper>;

  return (
    <li
      key={entryName}
      className={cn(styles.li, styles[`li${siblingsAmount}`])}
    >
      <Icon image={image} images={images} />
      <Title
        richText={richTitle}
        config={parsersConfig}
      />
      <Content
        richText={content}
        config={parsersConfig}
      />
    </li>
  );
};

export default PlainItem;
